module.exports = __webpack_public_path__ + "img/women.cea707bb.png";